//
// Login:
//

export const index = {
    path   : '/user_roles/:user_role_id/rates/',
    method : 'GET',
    version: '/v1'
}

export const getItem = {
  path   : '/user_roles/:user_role_id/rates/:user_role_rate_id/',
  method : 'GET',
  version: '/v1'
}

export const addItem = {
  path   : '/user_roles/:user_role_id/rates/',
  method : 'POST',
  version: '/v1'
}

export const updateItem = {
  path   : '/user_roles/:user_role_id/rates/:user_role_rate_id/',
  method : 'POST',
  version: '/v1'
}

export const deleteItem = {
  path   : '/user_roles/:user_role_id/rates/:user_role_rate_id/',
  method : 'DELETE',
  version: '/v1'
}
